const posterSizes = {
    w92: "w92",
    w154: "w154", 
    w185: "w185", 
    w342: "w342", 
    w500: "w500", 
    w780: "w780", 
    original: "original"
  }
  
  export default posterSizes;